import React from 'react'
import { ThemeColors } from '../../new/theme/colors'
import { TooltipProps } from '../tooltip'

export interface OptionProps<ValueType = string> {
  backgroundColor?: ThemeColors
  category?: string
  children: React.ReactNode
  customContentOpener?: boolean
  disabled?: boolean
  hidden?: boolean
  hideDropdownOnclick?: boolean
  hoverBackgroundColor?: ThemeColors
  hoverColor?: ThemeColors
  isCategoryControl?: boolean
  isCategoryLabel?: boolean
  isWithBottomDivider?: boolean
  onClickCustom?: () => void
  renderAsSelected?: () => React.ReactNode
  searchValue?: string
  sticky?: boolean
  tip?: TooltipProps['tip']
  tipOffset?: TooltipProps['offset']
  value: ValueType
}

export const Option = <ValueType extends unknown = string>({
  children,
}: OptionProps<ValueType>) => <>{children}</>
